// Official CyberTales Learning badge mark (public/logo-*.png). The wordmark
// ("CYBERTALES LEARNING — Stories. Skills. Safer Futures.") is baked into
// the artwork, so no separate text label is rendered alongside it.
export function Logo({ size = 40 }: { size?: number }) {
  return (
    <img
      src="/logo-192.png"
      alt="CyberTales Learning — Stories. Skills. Safer Futures."
      width={size}
      height={size}
      className="shrink-0 select-none object-contain drop-shadow-[0_0_10px_rgba(34,211,238,0.25)]"
      style={{ height: size, width: size }}
      draggable={false}
    />
  )
}
